module.exports = __webpack_public_path__ + "img/애고미_이모티콘-30.5280e3a.png";